export default "__VITE_ASSET__ByLDZiRu__"